import { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';
import './tailwind.css';
import SidebarAgenziaMenu from './SidebarAgenziaMenu'; // Importa la sidebar specifica per Agenzia
import TopBarMobile from './TopBarMobile';
import { Outlet, useNavigate } from 'react-router-dom';

export default function DashboardAgenzia() {
  const [userData, setUserData] = useState({ nome: '', cognome: '', ruolo: null });
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
      const userId = sessionData?.session?.user?.id;

      if (sessionError || !userId) {
        console.error('Nessuna sessione utente o errore:', sessionError?.message);
        navigate('/'); // Reindirizza al login se non autenticato
        return;
      }

      const { data: utente, error: userProfileError } = await supabase
        .from('utenti')
        .select('nome, cognome, ruolo')
        .eq('id', userId)
        .single();

      if (userProfileError || !utente) {
        console.error('Errore nel caricamento del profilo utente:', userProfileError?.message);
        navigate('/'); // Reindirizza se il profilo non è trovato
        return;
      }

      // ⭐ Controllo specifico del ruolo: solo 'agenzia' può accedere qui ⭐
      if (utente.ruolo !== 'agenzia') {
        console.warn(`Utente ${utente.nome} ${utente.cognome} con ruolo ${utente.ruolo} ha tentato di accedere a DashboardAgenzia.`);
        // Reindirizza l'utente a una dashboard appropriata o alla home/login
        if (utente.ruolo === 'broker') {
          navigate('/dashboard/broker');
        } else if (utente.ruolo === 'agente') {
          navigate('/dashboard/agente');
        } else {
          navigate('/'); // Fallback
        }
        return;
      }

      setUserData({ nome: utente.nome, cognome: utente.cognome, ruolo: utente.ruolo });
      setLoading(false);
    };

    fetchUserData();

    const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
      if (!session) {
        navigate('/');
      }
    });

    return () => {
      authListener?.data?.unsubscribe();
    };
  }, [navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50 text-slate-800">
        <p className="text-xl font-semibold">Caricamento dashboard Agenzia...</p>
      </div>
    );
  }

  if (userData.ruolo !== 'agenzia') {
    return null;
  }

  return (
    <div className="flex flex-col md:flex-row h-screen w-screen overflow-hidden bg-gray-50 text-slate-800 font-sans">
      <SidebarAgenziaMenu
        nome={userData.nome}
        cognome={userData.cognome}
        isOpen={isSidebarOpen}
        closeSidebar={() => setSidebarOpen(false)}
        userRole={userData.ruolo}
      />

      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {!isSidebarOpen && (
        <TopBarMobile
          nome={userData.nome}
          cognome={userData.cognome}
          toggleSidebar={() => setSidebarOpen(true)}
        />
      )}

      <div className={`flex-1 overflow-y-auto transition-all duration-300 ease-in-out`}>
        <main className="p-4 md:p-8 pt-[84px] md:pt-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}